export class DailyReportModel {
  public static IRI = '/api/daily_report_manuel';
}
